
import "./TestStyles.css";
import { handleOnPopState } from '../utils/pop_state_utils.js';
import React, { useState, useRef, useEffect, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { startRecording } from "../utils/recording_utils.js";
import { calculate_progress } from "../utils/progress_bar.js";
 
import { playInstructionsOnce, handleAudioEndedCommon } from '../utils/audio_utils.js';

const QuestionEighteenScreen = ({ userData }) => {
  const [audio] = useState(new Audio("/audio/q18_instructions.mp3"));
  const [isRecording, setIsRecording] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [imageButtonContainerStyle, setImageButtonContainerStyle] = useState("ImageButtonContainerHalf");
  const [nextButtonStyle, setNextButtonStyle] = useState("NextButton");
  const [audioPlayed, setAudioPlayed] = useState(false);
  const [, setRecordingExists] = useState(false);
  const [, setRecordingButtonDisabled] = useState(true);    
  const [endAudio, setEndAudio] = useState(new Audio("/audio/stop-13692.mp3"));
  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const results = JSON.parse(localStorage.getItem("results"));
  const navigate = useNavigate();
  const location = useLocation();
  const [nextPage] = useState("/Q18BScreen");        // Where this screen will navigate to next
  const [thisPage] = useState("screen_18");  
  const [filenameSuffix] = useState("Q18");
    const handleAudioEnded = useCallback(() => {
    handleAudioEndedCommon({
      audio,
      onEnded: handleAudioEnded,
      setAudioPlayed,
      setButtonDisabled,
      setRecordingButtonDisabled,
      setImageButtonContainerStyle,
      imageButtonEnabledClass: "ImageButtonContainerEnabledHalf",
      setNextButtonStyle
    });
  }, [audio]);

   
  // Implementing the popstate handler
  window.onpopstate = () => {
    handleOnPopState({ results, userData, navigate, location });
  };

  // Play instructions once after rendering
  useEffect(() => {
    playInstructionsOnce({ audio, audioPlayed, setAudioPlayed, onEnded: handleAudioEnded });
}, [audio, audioPlayed, handleAudioEnded]);

  /**
   * The function `playEndAudio` sets the volume of an audio element to 1, plays the audio, and assigns
   * a new audio element to a variable.
   */
  const playEndAudio = () => {
    endAudio.volume = 1;
    endAudio.play();
    setEndAudio(new Audio("/audio/stop-13692.mp3"));
  };

  // The function `handleStartRecording` is used to start the recording process.
  const handleStartRecording = async () => {
    await startRecording({
      setImageButtonContainerStyle,
      audioChunksRef,
      mediaRecorderRef,
      setIsRecording,
      setRecordingExists,
      userData,
      screenId: thisPage,
      screenTag: filenameSuffix,
      results,
      recordingStyle: "ImageButtonContainerRecordingHalf"
    });
  };

  /**
   * The function `stopRecording` stops the recording, plays an end audio, sets a flag to indicate that
   * recording is not in progress, stops the media recorder, and updates the style of an image button
   * container.
   */
  const stopRecording = async () => {
    if (!mediaRecorderRef.current) return;
    setIsRecording(false);
    await playEndAudio();
    mediaRecorderRef.current.stop();
    await mediaRecorderRef.current.stopPromise; 
    setImageButtonContainerStyle("ImageButtonContainerCompleteHalf");
  };

  return (
    <div className="Container">
      <div className="InstructionsContainer">
        <img className="CharacterIcon" src="/icons/other.png" alt="Character Icon" />
        <progress variant="custom" className="ProgressBar" value={calculate_progress('asymptotic', 44, 54)} max="1"></progress>
        <p className="Instructions">Press the microphone and name the letter.</p>
      </div>
      <div className="whiteScreenBlank">
      
      </div>
      <div>
        <img className="imageHalf" src="/icons/k.png" alt="k" />
        {isRecording ? (
          <button className={imageButtonContainerStyle} disabled={buttonDisabled} onClick={stopRecording}>
            <img className="microphoneIconHalf" src="/icons/microphone.png" alt="Microphone Button" />
          </button>
        ) : (
          <button className={imageButtonContainerStyle} disabled={buttonDisabled} onClick={handleStartRecording}>
            <img className="microphoneIconHalf" src="/icons/microphone.png" alt="Microphone Button" />
          </button>
        )}
      </div>
     

      <div className="NextButtonContainer">
        <button disabled={buttonDisabled} onClick= {async () => {
          if (isRecording) {
            await stopRecording();
          }
          navigate(nextPage)
          }}  className={nextButtonStyle}>
          <img src="/icons/arrow.png" alt="Next Button" />
        </button>
      </div>
    </div>
  );
};

export default QuestionEighteenScreen;
